import { createLink } from '../elemente/helpers/createLink';
import * as React from 'react';
import { renderTable } from './renderTable';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';
import { WpdfView } from '../../datenauswertung/pdf/WpdfView';
import { WpdfText } from '../../datenauswertung/pdf/WpdfText.';

export interface EnergiekostenQuellenProps {
    data: any;
    isClosed?: boolean;
}

export interface EnergiekostenQuellenState {
    isClosed: boolean;
}

export class EnergiekostenQuellen extends React.Component<EnergiekostenQuellenProps, EnergiekostenQuellenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            isClosed: !!this.props.isClosed,
        };
    }

    getTable(): any {
        const tbody: any = this.getTableBody();
        const thead: any = this.getTableHeader();

        return {
            rows: [...thead.rows, ...tbody.rows],
            rowStyles: [...thead.rowStyles, ...tbody.rowStyles],
        };
    }

    getTableBody(): any {
        const tbody: any = { rows: [], rowStyles: [] };
        const width: number = 400 / 2;
        const styleDefault: string[] = [`width:${width}`, 'center', 'narrow'];
        const styleMarginLeft: any = { marginLeft: '3pt' };

        if (this.state.isClosed) {
            return tbody;
        }
        tbody.rows.push([
            this.renderQuellenPrognosedaten(),
        ]);
        tbody.rowStyles.push([
            ['width:1199'],
        ]);
        tbody.rows.push([
            'nicht enthaltene Energieträger', 'Vergleichbare UBA-Energieträger'
        ]);
        tbody.rowStyles.push([...Array.from(Array(2).keys()).map(() =>
            [[...styleDefault, 'head', 'bold'], styleMarginLeft]
        )]);
        tbody.rows.push([
            'Fernkälte', 'Fernwärme'
        ]);
        tbody.rowStyles.push([...Array.from(Array(2).keys()).map(() =>
            [[...styleDefault, 'light'], styleMarginLeft]
        )]);
        tbody.rows.push([
            'Bioethanol', 'Biomethan'
        ]);
        tbody.rowStyles.push([...Array.from(Array(2).keys()).map(() =>
            [[...styleDefault, 'light', 'noborder-bottom'], styleMarginLeft]
        )]);
        tbody.rows.push([
            'Biodiesel', null
        ]);
        tbody.rowStyles.push([...Array.from(Array(2).keys()).map(() =>
            [[...styleDefault, 'light', 'noborder-top'], styleMarginLeft]
        )]);
        tbody.rows.push([
            'Erdgas - CNG', 'Erdgas'
        ]);
        tbody.rowStyles.push([...Array.from(Array(2).keys()).map(() =>
            [[...styleDefault, 'light', 'noborder-bottom'], styleMarginLeft]
        )]);
        tbody.rows.push([
            'Erdgas - LNG', null
        ]);
        tbody.rowStyles.push([...Array.from(Array(2).keys()).map(() =>
            [[...styleDefault, 'light', 'noborder-top', 'noborder-bottom'], styleMarginLeft]
        )]);
        tbody.rows.push([
            'LPG', null
        ]);
        tbody.rowStyles.push([...Array.from(Array(2).keys()).map(() =>
            [[...styleDefault, 'light', 'noborder-top', 'noborder-bottom'], styleMarginLeft]
        )]);
        tbody.rows.push([
            'Flüssiggas', null
        ]);
        tbody.rowStyles.push([...Array.from(Array(2).keys()).map(() =>
            [[...styleDefault, 'light', 'noborder-top'], styleMarginLeft]
        )]);
        tbody.rows.push([
            'Kohle - Braunkohle', 'Heizöl'
        ]);
        tbody.rowStyles.push([...Array.from(Array(2).keys()).map(() =>
            [[...styleDefault, 'light', 'noborder-bottom'], styleMarginLeft]
        )]);
        tbody.rows.push([
            'Kohle - Steinkohle', null
        ]);
        tbody.rowStyles.push([...Array.from(Array(2).keys()).map(() =>
            [[...styleDefault, 'light', 'noborder-top'], styleMarginLeft]
        )]);
        tbody.rows.push([
            this.renderQuellenInflation(),
        ]);
        tbody.rowStyles.push([
            [['width:1199'], { paddingTop: '8pt' }],
        ]);

        return tbody;
    }

    getTableHeader(): any {
        const thead: any = { rows: [], rowStyles: [] };
        thead.rows.push([
            this.renderTitle(),
        ]);
        thead.rowStyles.push([
            [['width:1199', 'title'], { paddingLeft: 10, borderRadius: '0pt 0pt 0 0' }],
        ]);

        return thead;
    }

    render(): JSX.Element {
        return renderTable(this.getTable());
    }

    renderHelp(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ marginLeft: 5, display: 'flex', alignSelf: 'center' }}
                styleProps={{ margin: 0 }}
                label='Energiekosten-Projektion - Quellen'
                helpKey='energiekosten_projektion_quellen'
                type='theme_info'
                style='theme_small'
                customElement='Info'
                editBar
                useTheme
            />
        );
    }

    renderQuellenInflation(): JSX.Element {
        const url: string = null;

        return <>
            <WpdfText style={{ fontWeight: 600, textDecoration: 'underline' }}>Inflation:</WpdfText>
            Für die Berücksichtigung der Inflation nutzen wir einen Wert von 2,1 %; dieser stammt aus folgender Quelle: {createLink(false, '...', url)}
        </>;
    }

    renderQuellenPrognosedaten(): JSX.Element {
        const url: string = 'https://www.umweltbundesamt.de/sites/default/files/medien/11850/publikationen/projektionen_2025_rahmendaten_endverbrauchspreise_2.auflage_bf.pdf';

        return <>
            <WpdfText style={{ fontWeight: 600, textDecoration: 'underline' }}>Prognosedaten:</WpdfText>
            Diese stammen aus der Studie {createLink(false, '"Endverbrauchspreise der Energieträger für die Treibhausgas-Projektionen 2025"', url)}, herausgegeben vom Umweltbundesamt.
            Für Energieträger, die in der UBA-Studie nicht enthalten sind, wurden vergleichbare Energieträger zur Ableitung der Steigerungsraten verwendet:
        </>;
    }

    renderTitle(): JSX.Element {
        return (
            <WpdfView
                data-text='Quellen'
                style={{ paddingRight: 30, display: 'inline-flex', lineHeight: 1.1, cursor: 'pointer', fontWeight: 600 }}
                onClick={() => this.setState({ isClosed: !this.state.isClosed })}
            >
                Quellen {this.state.isClosed ? <>&#9654;</> : <>&#9660;</>}{/*this.renderHelp()*/}
            </WpdfView>
        );
    }
}
